import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

import {
	GlobalService,
	MigaDePan,
} from "src/app/_core/providers/global.service";
import { getHomeMenuWithVisited } from "src/app/_core/constants/menu.constants";

interface AdminOption {
	icon: string;
	route: string;
	titleKey: string;
	descKey: string;
}

/**
 * Landing de Administración (ui-redesign). Cabecera con eyebrow/título/descripción +
 * lord-icon, y bajo ella las opciones de configuración y gobernanza. De momento solo
 * "Gestión de permisos", que navega a la administración de usuarios existente
 * (/admin/permissions), colgando jerárquicamente de Administración.
 */
@Component({
	selector: "app-admin-home",
	templateUrl: "./admin-home.page.html",
	styleUrls: ["./admin-home.page.scss"],
	standalone: false,
})
export class AdminHomePageComponent implements OnInit {
	private readonly menu = getHomeMenuWithVisited("/admin");

	readonly options: AdminOption[] = [
		{
			icon: "admin_panel_settings",
			route: "/admin/permissions",
			titleKey: "admin.home.permisos.title",
			descKey: "admin.home.permisos.desc",
		},
		{
			icon: "manage_accounts",
			route: "/admin/roles",
			titleKey: "roles.title",
			descKey: "roles.desc",
		},
		{
			icon: "badge",
			route: "/admin/positions",
			titleKey: "positions.title",
			descKey: "positions.desc",
		},
	];

	constructor(
		private readonly titleService: Title,
		private readonly translate: TranslateService,
		private readonly router: Router,
		private readonly global: GlobalService,
	) {
		const miga: MigaDePan[] = [
			{ nombre: "header.menu.admin", url: window.location.href },
		];
		this.global.limpiarMigas();
		this.global.actualizarMigas(miga);
	}

	ngOnInit(): void {
		this.titleService.setTitle(this.translate.instant("header.menu.admin"));
		this.global.setHeaderOptions([], null, [], this.menu);
	}

	go(route: string): void {
		this.router.navigate([route]);
	}
}
